import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { SheetsDisplayGridRowDataFragmentGql } from './SheetsDisplayGridRowFragmentGql';

export const TableDownstreamSheetsFilteredByColumnQueryGql: DocumentNode = gql`
query TableDownstreamSheetsFilteredByColumnQuery($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowDataFragment
      }
    }
  }
}
${SheetsDisplayGridRowDataFragmentGql}
`;
